import allUsers from "./allUsers"
import gameConfig from "./gameConfig"
import population from "./population"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = { allUsers, gameConfig, population }
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
const allUsersThunk = allUsers.thunk
const gameConfigThunk = gameConfig.thunk
const populationThunk = population.thunk
export { allUsersThunk as allUsers, gameConfigThunk as gameConfig, populationThunk as population }
